import { useState } from "react";
import { palette } from "../../../../../assets/theme/theme"
import CustomButtonSimple from "../../../../../components/CustomMiscellaneous/CustomButtonSimple"
import QRCodeGenerator from "../../../../../components/QRCodes/QRCodeGenerator"
import Form from "../../../../../form";
import { ExpedicoesConfig } from "../../../../Peças/Expedicoes/Expedicoes.config";
import FotoOperacaoDisplay from "../FotoOperacaoExterna"
import CloseIcon from '@mui/icons-material/Close';
import { QrCodeScanner } from "@mui/icons-material"
import { useFormType } from "../../../../../form/hooks/useForm";
import { ExpedicaoOperacaoExternaForm } from "./ExpedicaoOperacaoExternaForm";
import AddIcon from '@mui/icons-material/Add';

type OperacaoExternaInput = {
    pecaEntrega: any,
    pecaEntregaId: number,
    operacao: any,
    expeditionIndex: number | undefined,
    setExpeditionIndex: Function,
    idx: number | undefined,
    openIndex: number | undefined,
    pecaIdx: number | undefined,
    form: useFormType,
    setPecasToDisplay: any

}


export function OperacaoExternaDisplay({ pecaEntrega, pecaEntregaId, operacao, expeditionIndex, setExpeditionIndex, idx, openIndex, pecaIdx, form, setPecasToDisplay }: OperacaoExternaInput) {

    const [expeditionOpenIndex, setExpeditionOpenIndex] = useState<number | null>(null);

    console.log("Operação: ", operacao.id);

    return (
        <div className="bg-zinc-100 rounded-md p-4 text-black">
            <p className="font-bold text-[1.2em] mb-3">Expedições</p>
            <span className="font-bold">Prevista para:</span> {operacao.dataExpedicao}
            {pecaEntrega.expedicoesOperacao ?
             <div className="mt-3"> 
                {pecaEntrega.expedicoesOperacao
                .filter((e: any) => e.operacao.id === operacao.id)
                .map((e: any, exp_idx: number) => {
                return (<div className="border border-zinc-600 bg-white rounded-md p-5 mb-3">

                    <div className="flex justify-between">
                        <div>
                            <p><span className="font-bold mb-2">Id:</span> {e.id}</p>
                            <p><span className="font-bold mb-2">Observacoes:</span> {e.observacoes}</p>
                            <p><span className="font-bold mb-2">Quantidade expedida:</span> {e.quantidade}</p>
                            <p><span className="font-bold mb-2">Guia:</span> {e.guia}</p>
                            
                            <p><span className="font-bold">Data efetiva:</span> {`${e.data?.split('T')[0]}`}</p>
                        </div>
                        {(exp_idx == expeditionOpenIndex && openIndex == pecaIdx) ? <><QRCodeGenerator style={{ margin: 10 }} value={`operacao_externa-${operacao.id}-${e.id}`} /><CloseIcon onClick={() => setExpeditionOpenIndex(-1)} /> </> : <QrCodeScanner onClick={() => setExpeditionOpenIndex(exp_idx)} style={{ cursor: 'pointer', margin: 30 }} />}

                    </div>
                    <div className="bg-zinc-200 p-5 rounded-md mt-3">
                        {e.fotos.length > 0 ? 
                        <FotoOperacaoDisplay operacaoId={operacao.id} expedicaoId={e.id} fotos={e.fotos} /> 
                        : <div>Nenhuma documentação associada à expedição</div>}
                    </div>
                </div>

                )
            })

            }
            </div> : null}
            <div className="w-1/4">
                <CustomButtonSimple
                    text={'Nova expedição'}
                    color={palette.orange}
                    onClick={() => setExpeditionIndex(idx)}
                    Icon={AddIcon}
                />
            </div>
            {expeditionIndex === idx ?
                <div style={{ padding: 20 }}>
                    <ExpedicaoOperacaoExternaForm
                        setExpeditionIndex={setExpeditionIndex}
                        operacao={operacao}
                        pecaEntregaId={pecaEntregaId}
                        form={form}
                        setPecasToDisplay={setPecasToDisplay}
                    />
                </div>
                : null}

        </div>

    )



}